export const hideOverlay = () => {
    //@ts-ignore
    const overlay = success_overlay as HTMLElement;
    overlay.setAttribute('hidden', 'true');
}